module.exports = __webpack_public_path__ + "static/img/图层65.63e69f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层65.png
// module id = ksik
// module chunks = 0